<template>
  <div id="habitationFormQuote">
        <SimpleStepperEmprunteur></SimpleStepperEmprunteur>
  </div>
</template>

<script>
import SimpleStepperEmprunteur from "./views/assurances/SimpleStepperEmprunteur.vue"
import Buefy from "buefy";
import Vue from "vue";

//import { FadeTransition } from "vue2-transitions";

Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultContainerElement: "#content",
});
export default {
  name: "App",
  components: {
    SimpleStepperEmprunteur,
  },
};
</script>
<style scoped>
.section-shaped .shape {
  z-index: unset !important;
}
</style>